import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

const propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element)
  ]).isRequired
};
const defaultProps = {};

const Wrapper = styled.p`
  font-size: 14px;
  color: #4a4a4a;
  line-height: 21px;
  margin: 5px;
`;

function Paragraph({ children }) {
  return <Wrapper>{children}</Wrapper>;
}

Paragraph.propTypes = propTypes;
Paragraph.defaultProps = defaultProps;

export default Paragraph;



// WEBPACK FOOTER //
// ./src/components/Paragraph/index.js